var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import Text from "../Text/Text";
import { getIncrementalGeneratedId } from "../../helpers/Utilities";
import styled from "styled-components";
var StyledRadioGroup = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 0.5rem;\n  flex-direction: ", ";\n"], ["\n  display: flex;\n  gap: 0.5rem;\n  flex-direction: ", ";\n"])), function (props) {
    return props.$orientation === "vertical" ? "column" : "row";
});
var RadioGroup = function (_a) {
    var name = _a.name, value = _a.value, _b = _a.size, size = _b === void 0 ? "medium" : _b, color = _a.color, disabled = _a.disabled, children = _a.children, label = _a.label, _c = _a.orientation, orientation = _c === void 0 ? "vertical" : _c, 
    // Events
    onChange = _a.onChange;
    var _d = React.useState(name), finalName = _d[0], setFinalName = _d[1];
    var _e = useState(null), selectedIndex = _e[0], setSelectedIndex = _e[1];
    var _f = useState(selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : 0), focusedIndex = _f[0], setFocusedIndex = _f[1];
    React.useEffect(function () {
        if (!name) {
            setFinalName("radio-" + getIncrementalGeneratedId());
        }
    }, [name]);
    var _g = useState(null), filteredChildren = _g[0], setFilteredChildren = _g[1];
    var _getSelectedIndex = function (index) {
        setSelectedIndex(index !== null && index !== void 0 ? index : 0);
        setFocusedIndex(index !== null && index !== void 0 ? index : 0);
    };
    var Label = label ? (typeof label === "string" ? (_jsx(Text, __assign({ variant: "label", size: "large" }, { children: label }))) : (label)) : null;
    React.useEffect(function () {
        setFilteredChildren(function () {
            if (!children)
                return null;
            return React.Children.map(children, function (child, index) {
                if (!child)
                    return null;
                if (React.isValidElement(child) && child.type) {
                    var childElement = child;
                    var childType = childElement.type;
                    if (childType.name === "Radio" ||
                        childType.name === "FormControlLabel") {
                        return React.cloneElement(childElement, __assign(__assign(__assign(__assign({ name: finalName, index: index, selected: selectedIndex === index }, (!childElement.props.size && size && { size: size })), (!childElement.props.color && color && { color: color })), (!childElement.props.disabled && disabled && { disabled: disabled })), { focused: focusedIndex === index, getSelectedIndex: _getSelectedIndex }));
                    }
                }
                else {
                    console.error("RadioGroup: Invalid child ".concat(child, " supplied, expected a Radio or FormControlLabel component"));
                }
            });
        });
    }, [
        finalName,
        value,
        size,
        color,
        disabled,
        children,
        selectedIndex,
        focusedIndex,
    ]);
    return (_jsxs(StyledRadioGroup, __assign({ "$orientation": orientation, role: "radiogroup" }, { children: [Label, filteredChildren] })));
};
export default RadioGroup;
var templateObject_1;
